export default __webpack_public_path__ + "static/media/IC00029-grid.43933dcf.svg";